export type AxisValueFormat = "compact" | "percent" | "roi" | "plain";

export function formatAxisCompact(value: number): string {
  if (!Number.isFinite(value)) return "";
  const abs = Math.abs(value);
  if (abs >= 1e12) return `${trimTrailingZero(value / 1e12)}T`;
  if (abs >= 1e9) return `${trimTrailingZero(value / 1e9)}B`;
  if (abs >= 1e6) return `${trimTrailingZero(value / 1e6)}M`;
  if (abs >= 1e3) return `${trimTrailingZero(value / 1e3)}K`;
  if (abs >= 100) return value.toFixed(0);
  if (abs >= 1) return value.toFixed(1);
  if (abs >= 0.01) return value.toFixed(2);
  return value.toPrecision(2);
}

function trimTrailingZero(n: number): string {
  const s = n.toFixed(1);
  return s.endsWith(".0") ? s.slice(0, -2) : s;
}

export function formatAxisPercent(value: number): string {
  if (!Number.isFinite(value)) return "";
  return `${value >= 100 || value <= -100 ? value.toFixed(0) : value.toFixed(1)}%`;
}

export function formatAxisRoi(value: number): string {
  if (!Number.isFinite(value)) return "";
  return `${formatAxisCompact(value)}×`;
}

export function axisTickFormatter(format: AxisValueFormat = "compact") {
  switch (format) {
    case "percent":
      return formatAxisPercent;
    case "roi":
      return formatAxisRoi;
    case "plain":
      return (v: number) => (Number.isFinite(v) ? String(v) : "");
    default:
      return formatAxisCompact;
  }
}

export function inferAxisFormat(yLabel: string): AxisValueFormat {
  if (/ROI|×|'s/i.test(yLabel)) return "roi";
  if (/%/.test(yLabel)) return "percent";
  if (/Stock To Flow/i.test(yLabel)) return "plain";
  return "compact";
}
